import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Nav.css';

export default function NavigationBar() {
  const [isSticky, setIsSticky] = useState(false);
  const [isNavExpanded, setIsNavExpanded] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  const handleNavLinkClick = () => {
    setIsNavExpanded(false); // Collapse the navbar when a link is clicked
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      sticky="top"
      className={`${isSticky ? "sticky" : ""}`}  // Add the sticky class dynamically
      expanded={isNavExpanded} // Control the expansion based on state
    >
      <Container>
        {/* Logo/Heading */}
        <Navbar.Brand as={Link} to="/">
          Shivek Group
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={() => setIsNavExpanded(!isNavExpanded)} // Toggle the state when the menu icon is clicked
        />

        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/" onClick={handleNavLinkClick}>
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/founder" onClick={handleNavLinkClick}>
              About
            </Nav.Link>
            <Nav.Link as={Link} to="/services" onClick={handleNavLinkClick}>
              Services
            </Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={handleNavLinkClick}>
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
